import { ShieldMark } from "./AnimatedShield";

// Official wordmark letter paths extracted from brand-assets/wordmark.svg.
// Coordinates are in the local space of the <g transform="translate(108,30)"> group,
// spanning x: 2.9–177.67, y: 11.88–52.10 (cap top to y-descender bottom).
const FORTIFY_PATH =
  "M8.71 43.30L2.90 43.30L2.90 12.50L22.26 12.50L22.26 17.78L8.71 17.78" +
  "L8.71 25.21L21.21 25.21L21.21 30.49L8.71 30.49L8.71 43.30Z" +
  "M35.90 43.91Q32.65 43.91 30.05 42.59Q27.46 41.27 25.96 38.76" +
  "Q24.46 36.26 24.46 32.74L24.46 32.03Q24.46 28.51 25.96 26.00" +
  "Q27.46 23.50 30.05 22.18Q32.65 20.86 35.90 20.86" +
  "Q39.16 20.86 41.76 22.18Q44.35 23.50 45.85 26.00" +
  "Q47.34 28.51 47.34 32.03L47.34 32.74Q47.34 36.26 45.85 38.76" +
  "Q44.35 41.27 41.76 42.59Q39.16 43.91 35.90 43.91Z" +
  "M35.90 38.98Q38.46 38.98 40.13 37.33Q41.80 35.68 41.80 32.60L41.80 32.16" +
  "Q41.80 29.08 40.15 27.43Q38.50 25.78 35.90 25.78" +
  "Q33.35 25.78 31.68 27.43Q30.01 29.08 30.01 32.16L30.01 32.60" +
  "Q30.01 35.68 31.68 37.33Q33.35 38.98 35.90 38.98Z" +
  "M57.11 43.30L51.57 43.30L51.57 21.47L57.02 21.47L57.02 23.94L57.82 23.94" +
  "Q58.30 22.62 59.42 22Q60.54 21.38 62.04 21.38L64.68 21.38L64.68 26.31" +
  "L61.95 26.31Q59.84 26.31 58.48 27.43Q57.11 28.56 57.11 30.89L57.11 43.30Z" +
  "M82.63 43.30L76.47 43.30Q74.32 43.30 72.97 41.95Q71.63 40.61 71.63 38.37" +
  "L71.63 26.05L66.18 26.05L66.18 21.47L71.63 21.47L71.63 14.70" +
  "L77.18 14.70L77.18 21.47L83.16 21.47L83.16 26.05L77.18 26.05" +
  "L77.18 37.40Q77.18 38.72 78.41 38.72L82.63 38.72L82.63 43.30Z" +
  "M92.84 43.30L87.30 43.30L87.30 21.47L92.84 21.47L92.84 43.30Z" +
  "M90.07 18.92Q88.57 18.92 87.54 17.95Q86.50 16.98 86.50 15.40" +
  "Q86.50 13.82 87.54 12.85Q88.57 11.88 90.07 11.88" +
  "Q91.61 11.88 92.62 12.85Q93.63 13.82 93.63 15.40" +
  "Q93.63 16.98 92.62 17.95Q91.61 18.92 90.07 18.92Z" +
  "M107.27 43.30L101.73 43.30L101.73 26.05L96.18 26.05L96.18 21.47" +
  "L101.73 21.47L101.73 17.42Q101.73 15.18 103.07 13.84" +
  "Q104.41 12.50 106.57 12.50L112.29 12.50L112.29 17.07L108.50 17.07" +
  "Q107.27 17.07 107.27 18.39L107.27 21.47L112.99 21.47L112.99 26.05" +
  "L107.27 26.05L107.27 43.30Z" +
  "M132.53 52.10L118.80 52.10L118.80 47.26L130.68 47.26" +
  "Q131.91 47.26 131.91 45.94L131.91 40.44L131.12 40.44" +
  "Q130.77 41.18 130.02 41.93Q129.27 42.68 128.00 43.16" +
  "Q126.72 43.65 124.74 43.65Q122.19 43.65 120.27 42.48" +
  "Q118.36 41.32 117.30 39.25Q116.25 37.18 116.25 34.50" +
  "L116.25 21.47L121.79 21.47L121.79 34.06Q121.79 36.52 123.00 37.75" +
  "Q124.21 38.98 126.46 38.98Q129.01 38.98 130.42 37.29" +
  "Q131.82 35.60 131.82 32.56L131.82 21.47L137.37 21.47" +
  "L137.37 47.17Q137.37 49.41 136.05 50.75Q134.73 52.10 132.53 52.10Z";

const ID_PATH =
  "M148.28 43.30L142.47 43.30L142.47 12.50L148.28 12.50L148.28 43.30Z" +
  "M165.00 43.30L152.33 43.30L152.33 38.19L156.38 38.19L156.38 17.60" +
  "L152.33 17.60L152.33 12.50L165.00 12.50Q171.20 12.50 174.44 15.64" +
  "Q177.67 18.79 177.67 24.99L177.67 30.80Q177.67 37.00 174.44 40.15" +
  "Q171.20 43.30 165.00 43.30Z" +
  "M162.18 17.78L162.18 38.02L165.09 38.02Q168.61 38.02 170.24 36.17" +
  "Q171.86 34.32 171.86 30.98L171.86 24.82Q171.86 21.43 170.24 19.60" +
  "Q168.61 17.78 165.09 17.78L162.18 17.78Z";

interface WordmarkProps {
  className?: string;
  size?: "sm" | "md" | "lg" | "xl";
  reversed?: boolean;
  showMark?: boolean;
  markTone?: string;
  markCut?: string;
  markVariant?: "filled" | "outline";
}

// viewBox captures cap-height band (y: 12.5 → 43.3) so the SVG sizes by
// the main letterforms. The "y" descender (to y≈52) overflows below;
// overflow="visible" lets it render without pushing the flex layout.
const TEXT_VIEWBOX = "2.9 12.5 174.77 30.8";

// Pixel heights matched to Tailwind text-size equivalents
const SIZES = {
  sm: { mark: "w-6 h-6", textH: 16, gap: "gap-2" },
  md: { mark: "w-8 h-8", textH: 20, gap: "gap-2.5" },
  lg: { mark: "w-10 h-10", textH: 24, gap: "gap-3" },
  xl: { mark: "w-14 h-14", textH: 36, gap: "gap-4" },
};

export function Wordmark({
  className = "",
  size = "md",
  reversed = false,
  showMark = true,
  markTone,
  markCut,
  markVariant,
}: WordmarkProps) {
  const s = SIZES[size];

  // Dark mode: "Fortify" near-black (#2A2826), "ID" forest green (#1E4A40)
  // Reversed (on dark bg): both white
  const fortifyFill = reversed ? "#FFFFFF" : "#2A2826";
  const idFill = reversed ? "#FFFFFF" : "#1E4A40";

  return (
    <div className={`flex items-center ${s.gap} ${className}`}>
      {showMark && (
        <div className={`${s.mark} shrink-0 block`}>
          <ShieldMark
            tone={markTone ?? (reversed ? "hsl(var(--brand-bone))" : "hsl(var(--brand-forest))")}
            cut={markCut ?? (reversed ? "hsl(var(--brand-forest))" : "hsl(var(--brand-sand))")}
            variant={markVariant}
          />
        </div>
      )}
      <svg
        viewBox={TEXT_VIEWBOX}
        height={s.textH}
        aria-label="FortifyID"
        role="img"
        style={{ display: "block", overflow: "visible", flexShrink: 0 }}
      >
        <path d={FORTIFY_PATH} fill={fortifyFill} />
        <path d={ID_PATH} fill={idFill} />
      </svg>
    </div>
  );
}
